import * as React from "react"
import { Box, Skeleton } from "@mui/material"
import { ButtonIconSeeker } from "@ui-seeker/core"
import { AppTableSeeker } from "@components"
import { translateCountryName } from "@ui-seeker/utils"

import { useToast } from "@hooks"
import { useStockShareSkuDetails } from "./@hooks"
import { buyboxColumn, dateColumn, percentageColumn, priceColumn, productSkuColumn, retailerColumn, sellerColumn, stockColumn } from "./columns"
import { stockShareSkuDetailsFilters } from "../../signals"


export default function StockShareTableSkuDetails() {
	const { showToast } = useToast()
	const {
		skuName,
		country,
		isLoadingDetailsTable,
		detailsTableData,
		handleCloseDetailsSkuTable,
		isStandardUser,
		userUseRRSP,
		urlApiSkuDetails
	} = useStockShareSkuDetails()
	
	if (isLoadingDetailsTable)
		return <Skeleton variant="rectangular" height={500} />

	if (!detailsTableData?.length)
		return <></>

	return <Box id="sku-details-table">
		<AppTableSeeker
			title={`Sku Details - ${skuName} - ${translateCountryName(country)}`}
			data={detailsTableData}
			columns={[
				dateColumn(),
				...retailerColumn(),
				...productSkuColumn(),
				priceColumn('listPrice', 'List Price'),
				priceColumn('actualPrice', 'Actual Price'),
				percentageColumn('promotion', 'Promotion'),
				...isStandardUser ? [buyboxColumn()] : [],
				...isStandardUser ? [sellerColumn()] : [],
				...stockColumn(),
				...userUseRRSP ? [priceColumn('rrsp', 'RRSP')] : [],
				...userUseRRSP ? [percentageColumn('diffVSrrsp', 'Diff Vs RRSP')] : []
			]}
			options={{
				customToolbar: () => <ButtonIconSeeker
					icon="times"
					onClick={handleCloseDetailsSkuTable}
					tooltip="Close Table"
				/>,
				// The URL segment is the *tab* id, and this screen splits by retailer
				// (`splitKpi: GROUPED_BY.RETAILER`), so it has to be the site — the row's
				// `siteIDFiltered`, which carries the `_3P` suffix for a marketplace seller.
				// Sending `sku[0]` made the backend filter `id_site = <a SKU id>`, so the
				// download came back with every price empty while its labels still looked right.
				onDownload: () => showToast.promiseExcel(`${urlApiSkuDetails}/excel/${stockShareSkuDetailsFilters.value.retailer[0]}`, {
					...stockShareSkuDetailsFilters.value,
				}, null, {
					onError: data => {
						if (data.toString().includes('Error')) return 'Excel file size exceeded'
					}
				})
			}}
		/>
	</Box>
}